// extracted by mini-css-extract-plugin
export default {"mask":"_5DkcpoCa","is-open":"_5DdNuodE","is-fixed":"_5DYg5H3F","content":"_5DnIFzu4"};